var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container pre-header"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"left-info"},[_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope"}),_vm._v("service@hzbc.cc")])]),_c('li',[_c('a',[_vm._v(" Copyright © 2022-2024 "),_c('a',[_vm._v("杭州宝船数据科技有限公司")])])])])])])])])])
}]

export { render, staticRenderFns }